import "core-js/modules/es6.number.constructor";
import { throttle } from '@/js/api/utils.js';
import { getScroll } from '@/js/api/height.js';
export default {
  name: 'UBackToTop',
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    }
  },
  data: function data() {
    return {
      show: false,
      showAnimation: false,
      lastTop: Infinity,
      scrollTop: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    window.addEventListener('scroll', throttle(function () {
      if (getScroll().top > _this.visibilityHeight) {
        _this.show = true;
      } else {
        _this.show = false;
      }
    }, 200, 2));
  },
  methods: {
    handleClick: function handleClick() {
      if (this.showAnimation) return;
      this.showAnimation = true;
      this.lastTop = Infinity;
      this.scrollAnimation();
    },
    scrollAnimation: function scrollAnimation() {
      this.scrollTop = Math.floor(getScroll().top - getScroll().top / 10);
      document.body.scrollTop = document.documentElement.scrollTop = this.scrollTop;
      var rafId = requestAnimationFrame(this.scrollAnimation);
      if (getScroll().top <= 0 || this.scrollTop > this.lastTop) {
        cancelAnimationFrame(rafId);
        this.showAnimation = false;
      }
      this.lastTop = this.scrollTop;
    }
  }
};